#import "../fragments/report-view-fragment.graphql"

query GetRecentlyViewedReports {
    recentlyViewedReports {
        ...ReportViewFields
    }
}
